import React, { useState } from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as PackStyles from "../step-customize/main-content/styles/Pack";
import * as InputStyles from "../../../../../../common-deprecated/styles/lexus/Input";
import Extra from "../common/extras/Extra";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { resolvePackConflict } from "../../../redux/actions/BasketActions";
import type { ExtraType, ModalViewType, PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import type { PackConflictModalType } from "../../../utils/modalConstants";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const PackConflictModal = (props: ModalViewType<PackConflictModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { pack, conflicts, selectedConflicts, isConflictBetweenPackExtras } = modalSettings;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const hasConflicts = !!(conflicts && conflicts.length > 0);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="packConflictTitle" />
                </Modal.Title>
                <Modal.Button onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>

            <Modal.Body>
                <PackStyles.Grid>
                    {isConflictBetweenPackExtras &&
                        hasConflicts &&
                        (conflicts as ExtraType[]).map((item) => (
                            <Extra
                                key={item.id}
                                extra={item}
                                equipped={selectedId === item.id}
                                onSelect={() => {
                                    if (!selectedId || selectedId !== item.id) setSelectedId(item.id);
                                    else setSelectedId(null);
                                }}
                                optional
                                enabled
                            />
                        ))}
                </PackStyles.Grid>
                <Flex.Col display="flex" flexWrap="wrap">
                    {!isConflictBetweenPackExtras && hasConflicts && (
                        <Flex.Row>
                            <Flex.Col display="flex" flexDirection="column">
                                {(conflicts as PackType[]).map((item) => (
                                    <InputStyles.Wrapper key={item.id} mb={2}>
                                        <input
                                            id={`${item.id}-conflict`}
                                            type="checkbox"
                                            checked={selectedId === item.id}
                                            name="conflicts"
                                            onChange={() => {
                                                if (!selectedId || selectedId !== item.id) setSelectedId(item.id);
                                                else setSelectedId(null);
                                            }}
                                        />
                                        <InputStyles.Checkbox htmlFor={`${item.id}-conflict`}>
                                            {item.name}
                                        </InputStyles.Checkbox>
                                    </InputStyles.Wrapper>
                                ))}
                            </Flex.Col>
                        </Flex.Row>
                    )}
                </Flex.Col>
            </Modal.Body>
            <Modal.Actions>
                <Flex.Col p={0} display="flex" justifyContent="flex-end">
                    <ButtonPrimary
                        disabled={!selectedId}
                        onClick={() => {
                            if (hasConflicts) {
                                let selectedItem;
                                if (isConflictBetweenPackExtras) {
                                    // TODO If time allows clean up so this can also be a WheelType conform the typing of pack equipment
                                    selectedItem = (pack.equipment as ExtraType[]).find(
                                        (extra) => selectedId === extra.id,
                                    );
                                } else {
                                    selectedItem = (conflicts as PackType[]).find((p) => selectedId === p.id);
                                }
                                if (selectedItem) {
                                    dispatch(
                                        resolvePackConflict(
                                            pack,
                                            selectedItem,
                                            conflicts,
                                            selectedConflicts,
                                            isConflictBetweenPackExtras,
                                        ),
                                    );
                                    close();
                                }
                            }
                        }}
                    >
                        <BnbLabel label="packConflictContinue" />
                    </ButtonPrimary>
                </Flex.Col>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default PackConflictModal;
